module.exports = __webpack_public_path__ + "img/homeLogo.319690dd.png";